import {
  TypedUseSelectorHook,
  useDispatch,
  useSelector
} from "react-redux"
import {
  configureStore as reduxConfigureStore,
  createAsyncThunk
} from "@reduxjs/toolkit"

import rootReducer from "./reducers";

function configureStore() {
  return reduxConfigureStore({
    reducer: rootReducer,
    devTools: import.meta.env.APP_ENVIRONMENT === 'development',
    middleware: (defaultMiddleware) =>
      defaultMiddleware().concat(
        ...[
          // Add middlewares here.
        ]
      ),
  });
}

export const store = configureStore();

export type AppDispatch = ReturnType<typeof configureStore>["dispatch"];
/*
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  AnyAction
>;
*/

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const createAppAsyncThunk = createAsyncThunk.withTypes<{
  state: RootState;
  dispatch: AppDispatch;
  rejectValue: string;
}>();
